export default __webpack_public_path__ + "static/media/cash.87bbcb09.png";